function mapTokenizationTypeSmartTokenization(type) {
  const types = {
    with_esc: 'smart_tokenization_esc',
    with_cvv: 'smart_tokenization_cvv',
    with_card_info: 'smart_tokenization_no_cvv_no_esc',
    hash_cvv: 'smart_tokenization_hash_cvv',
  };
  return types[type] || '';
}

function mapTokenizationTypeLegacy(type) {
  const types = {
    with_esc: 'with_esc_legacy',
    with_cvv: 'with_cvv_legacy',
  };
  return types[type] || false;
}

/**
 * Maps tokenization type based on legacy flag
 * @param {string} params.type - The tokenization type
 * @param {boolean} params.isLegacy - Whether to use legacy mapping
 * @returns {string || boolean} The mapped tokenization type
 */

export function mappingTokenizationType({ type, isLegacy = true }) {
  if (isLegacy) return mapTokenizationTypeLegacy(type);
  return mapTokenizationTypeSmartTokenization(type);
}
